import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { authStore } from "@/lib/api";

export default function AdminLogin() {
    const [email, setEmail] = useState("admin@colecle.com");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            if (!["super_admin", "admin", "sales", "marketing"].includes(data.user.role)) {
                throw new Error("Not authorized for admin portal");
            }
            authStore.setSession(data.token, data.user);
            toast.success("Signed in to admin");
            nav("/admin");
        } catch (err) {
            toast.error(err?.response?.data?.detail || err.message || "Login failed");
        }
        setLoading(false);
    };

    return (
        <main data-testid="admin-login" className="min-h-screen bg-[#0B1930] text-white flex items-center justify-center">
            <div className="hero-glow top-0 right-0" style={{ background: "#E8B923", opacity: 0.15 }} />
            <form onSubmit={submit} className="w-full max-w-md bg-white text-navy rounded-2xl p-10 relative">
                <div className="flex items-center gap-2.5 mb-8">
                    <div className="w-8 h-8 rounded-md bg-gradient-to-br from-[#E8B923] to-[#C99F0F] flex items-center justify-center text-navy font-serif text-lg font-bold">C</div>
                    <span className="font-serif text-xl text-navy">Colecle</span>
                </div>
                <div className="eyebrow eyebrow--slate">Administration</div>
                <h1 className="font-serif text-3xl mt-3">Sign in to Admin</h1>
                <div className="mt-6 space-y-4">
                    <input data-testid="admin-email" required type="email" placeholder="Admin email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-slate-200 rounded-md px-4 py-3" />
                    <input data-testid="admin-password" required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-slate-200 rounded-md px-4 py-3" />
                    <button data-testid="admin-submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? "Signing in…" : "Sign in"}</button>
                </div>
            </form>
        </main>
    );
}
